import { createAction } from "redux-actions";

import {
  REQUEST_BLANK_PRODUCT_SUCCESS,
  REQUEST_BLANK_PRODUCT_FAILURE,
  ADD_OR_UPDATE_BLANK_PRODUCT_SUCCESS,
  ADD_OR_UPDATE_BLANK_PRODUCT_FAILURE,
  REQUEST_BLANK_PRODUCTS_ADDED_BY_ADMIN_SUCCESS,
  REQUEST_BLANK_PRODUCTS_ADDED_BY_ADMIN_FAILURE,
  GET_BLANKSETTINGS_AND_PRICING_INFO_SUCCESS,
  GET_BLANKSETTINGS_AND_PRICING_INFO_FAILURE,
  REQUEST_NEW_BLANK_PRODUCT_SUCCESS,
  REQUEST_NEW_BLANK_PRODUCT_FAILURE,
  SAVE_BLANK__PRODUCT_PLACEMENT_DETAILS_SUCCESS,
  SAVE_BLANK__PRODUCT_PLACEMENT_DETAILS_FAILURE,
  GET_ENABLED_BLANK_PRODUCTS_SUCCESS,
  GET_ENABLED_BLANK_PRODUCTS_FAILURE,
  GET_ENABLED_BLANK_PRODUCT_DETAILS_SUCCESS,
  GET_ENABLED_BLANK_PRODUCT_DETAILS_FAILURE,
  SAVE_NEW_PRODUCT_PLACEMENT_DETAILS_SUCCESS,
  SAVE_NEW_PRODUCT_PLACEMENT_DETAILS_FAILURE,
  UPDATE_PRODUCT_PLACEMENT_DETAILS_SUCCESS,
  UPDATE_PRODUCT_PLACEMENT_DETAILS_FAILURE,
  DELETE_BLANK_PRODUCT_SUCCESS,
  DELETE_BLANK_PRODUCT_FAILURE,
  UPDATE_BACKGROUND_IMAGES_SUCCESS,
  UPDATE_BACKGROUND_IMAGES_FAILURE,
  GET_SIMILAR_BLANK_PRODUCTS_SUCCESS,
  GET_SIMILAR_BLANK_PRODUCTS_FAILURE,
  STORE_SIMILAR_PRODUCTS_SUCCESS,
  STORE_SIMILAR_PRODUCTS_FAILURE,
  UPDATE_BLANK_PRODUCT_RECOMMENDATION_SUCCESS,
  UPDATE_BLANK_PRODUCT_RECOMMENDATION_FAILURE,
  REQUEST_SUPPLIER_RECOMMENDED_BLANK_PRODUCT_FAILURE,
  REQUEST_SUPPLIER_RECOMMENDED_BLANK_PRODUCT_SUCCESS,
  SET_BULK_SEND_TO_CHANNEL_JOB,
  CLEAR_BULK_SEND_TO_CHANNEL_JOB,
} from "../constants/actionTypes";
import * as BlankProducts from "../api/blankProducts";

const requestBlankProductsAddedByAdminSuccess = createAction(
  REQUEST_BLANK_PRODUCTS_ADDED_BY_ADMIN_SUCCESS
);
const requestBlankProductsAddedByAdminFailure = createAction(
  REQUEST_BLANK_PRODUCTS_ADDED_BY_ADMIN_FAILURE
);

// updating the name of the blankproduct with the setting name provided by the user
const transformBlankProductAddedByAdminData = (blankProductData) => {
  let { blankProducts } = blankProductData.data;

  let updatedBlankProducts = [];

  blankProducts.forEach((bp) => {
    let { blankSettings } = bp;

    updatedBlankProducts = [
      ...updatedBlankProducts,
      {
        ...bp,
        name: blankSettings.name || bp.name,
      },
    ];
  });

  return {
    ...blankProductData,
    data: {
      ...blankProductData.data,
      blankProducts: updatedBlankProducts,
    },
  };
};

export function requestBlankProductsAddedByAdmin(params, id) {
  return (dispatch) =>
    BlankProducts.requestBlankProductsAddedByAdmin(params, id)
      .then((data) => {
        const transformedBlankProductData =
          transformBlankProductAddedByAdminData(data);
        return dispatch(
          requestBlankProductsAddedByAdminSuccess(transformedBlankProductData)
        );
      })
      .catch((error) =>
        dispatch(requestBlankProductsAddedByAdminFailure(error))
      );
}

// updating the name of the blankproduct with the setting name provided by the user
const transformBlankProductData = (blankProductData) => {
  let { blankProduct = {}, blankProductSettings = {} } = blankProductData.data;

  blankProduct = {
    ...blankProduct,
    name: blankProductSettings.name || blankProduct.name,
  };

  return {
    ...blankProductData,
    data: {
      ...blankProductData.data,
      blankProduct,
    },
  };
};

const requestBlankProductSuccess = createAction(REQUEST_BLANK_PRODUCT_SUCCESS);
const requestBlankProductFailure = createAction(REQUEST_BLANK_PRODUCT_FAILURE);

export function requestBlankProduct(id, query) {
  return (dispatch) =>
    BlankProducts.requestBlankProduct(id, query)
      .then((data) => {
        const transformedBlankProductData = transformBlankProductData(data);

        return dispatch(
          requestBlankProductSuccess(transformedBlankProductData)
        );
      })
      .catch((error) => dispatch(requestBlankProductFailure(error)));
}

const requestSupplierRecommendedBlankProductSuccess = createAction(
  REQUEST_SUPPLIER_RECOMMENDED_BLANK_PRODUCT_SUCCESS
);
const requestSupplierRecommendedBlankProductSuccessFailure = createAction(
  REQUEST_SUPPLIER_RECOMMENDED_BLANK_PRODUCT_FAILURE
);

export function requestSupplierRecommendedBlankProduct(id, data) {
  return (dispatch) =>
    BlankProducts.requestRecommendedBlankProduct(id, data)
      .then((res) => {
        const transformedBlankProductData = transformBlankProductData(res);

        return dispatch(
          requestSupplierRecommendedBlankProductSuccess(
            transformedBlankProductData
          )
        );
      })
      .catch((error) =>
        dispatch(requestSupplierRecommendedBlankProductSuccessFailure(error))
      );
}

const requestNewBlankProductSuccess = createAction(
  REQUEST_NEW_BLANK_PRODUCT_SUCCESS
);
const requestNewBlankProductFailure = createAction(
  REQUEST_NEW_BLANK_PRODUCT_FAILURE
);
export function requestNewBlankProduct(supplierId, blankId) {
  return (dispatch) =>
    BlankProducts.requestNewBlankProduct(supplierId, blankId)
      .then((data) => dispatch(requestNewBlankProductSuccess(data)))
      .catch((error) => dispatch(requestNewBlankProductFailure(error)));
}

const addOrUpdateBlankProductSuccess = createAction(
  ADD_OR_UPDATE_BLANK_PRODUCT_SUCCESS
);
const addOrUpdateBlankProductFailure = createAction(
  ADD_OR_UPDATE_BLANK_PRODUCT_FAILURE
);

export function addOrUpdateBlankProduct(params, id) {
  return (dispatch) =>
    BlankProducts.addOrUpdateBlankProduct(params, id)
      .then((data) => dispatch(addOrUpdateBlankProductSuccess(data)))
      .catch((error) => dispatch(addOrUpdateBlankProductFailure(error)));
}

const updateBlankProductRecommendationSuccess = createAction(
  UPDATE_BLANK_PRODUCT_RECOMMENDATION_SUCCESS
);
const updateBlankProductRecommendationFailure = createAction(
  UPDATE_BLANK_PRODUCT_RECOMMENDATION_FAILURE
);

export function updateBlankProductRecommendation(params, id) {
  return (dispatch) =>
    BlankProducts.updateBlankProductRecommendation(params, id)
      .then((data) =>
        dispatch(updateBlankProductRecommendationSuccess({ params, id }))
      )
      .catch((error) =>
        dispatch(updateBlankProductRecommendationFailure(error))
      );
}

const deleteBlankProductSuccess = createAction(DELETE_BLANK_PRODUCT_SUCCESS);
const deleteBlankProductFailure = createAction(DELETE_BLANK_PRODUCT_FAILURE);

export function deleteBlankProduct(id, options) {
  return (dispatch) =>
    BlankProducts.deleteBlankProduct(id, options)
      .then(({ data }) => dispatch(deleteBlankProductSuccess({ id, data })))
      .catch((error) => dispatch(deleteBlankProductFailure(error)));
}

/** Drop a blank from the in-memory catalog list without calling delete again. */
export function forgetAddedBlank(id) {
  return deleteBlankProductSuccess({ id });
}

const getBlankSettingsAndPricingInfoSuccess = createAction(
  GET_BLANKSETTINGS_AND_PRICING_INFO_SUCCESS
);
const getBlankSettingsAndPricingInfoFailure = createAction(
  GET_BLANKSETTINGS_AND_PRICING_INFO_FAILURE
);

export function getBlankSettingsAndPricingInfo(params, id) {
  return (dispatch) =>
    BlankProducts.getBlankSettingsAndPricingInfo(params, id)
      .then((data) => dispatch(getBlankSettingsAndPricingInfoSuccess(data)))
      .catch((error) => dispatch(getBlankSettingsAndPricingInfoFailure(error)));
}

const saveBlankProductPlacementDetailsSuccess = createAction(
  SAVE_BLANK__PRODUCT_PLACEMENT_DETAILS_SUCCESS
);
const saveBlankProductPlacementDetailsFailure = createAction(
  SAVE_BLANK__PRODUCT_PLACEMENT_DETAILS_FAILURE
);

export function saveBlankProductPlacementDetails(id, data) {
  return (dispatch) =>
    BlankProducts.saveBlankProductPlacementDetails(id, data)
      .then(({ data }) =>
        dispatch(saveBlankProductPlacementDetailsSuccess(data))
      )
      .catch((error) =>
        dispatch(saveBlankProductPlacementDetailsFailure(error))
      );
}

const getEnabledBlankProductsSuccess = createAction(
  GET_ENABLED_BLANK_PRODUCTS_SUCCESS
);
const getEnabledBlankProductsFailure = createAction(
  GET_ENABLED_BLANK_PRODUCTS_FAILURE
);
export function getEnabledBlankProducts(query) {
  return (dispatch) =>
    BlankProducts.getEnabledBlankProducts(query)
      .then((data) => dispatch(getEnabledBlankProductsSuccess(data)))
      .catch((error) => dispatch(getEnabledBlankProductsFailure(error)));
}

// updating the name of the blankproduct with the setting name provided by the user
const transformEnabledBlankProductData = (blankProductData) => {
  let { settings = {} } = blankProductData.data;

  return {
    ...blankProductData,
    data: {
      ...blankProductData.data,
      name: settings.name || blankProductData.data.name,
    },
  };
};

const getEnabledBlankProductDetailsSuccess = createAction(
  GET_ENABLED_BLANK_PRODUCT_DETAILS_SUCCESS
);
const getEnabledBlankProductDetailsFailure = createAction(
  GET_ENABLED_BLANK_PRODUCT_DETAILS_FAILURE
);

export function getEnabledBlankProductDetails(id) {
  return (dispatch) =>
    BlankProducts.getEnabledBlankProductDetails(id)
      .then((data) => {
        const transformedBlankProductData =
          transformEnabledBlankProductData(data);

        return dispatch(
          getEnabledBlankProductDetailsSuccess(transformedBlankProductData)
        );
      })
      .catch((error) => dispatch(getEnabledBlankProductDetailsFailure(error)));
}

const saveNewProductPlacementDetailsSuccess = createAction(
  SAVE_NEW_PRODUCT_PLACEMENT_DETAILS_SUCCESS
);
const saveNewProductPlacementDetailsFailure = createAction(
  SAVE_NEW_PRODUCT_PLACEMENT_DETAILS_FAILURE
);
export function saveNewProductPlacementDetails(params) {
  return (dispatch) =>
    BlankProducts.saveNewProductPlacementDetails(params)
      .then((data) => dispatch(saveNewProductPlacementDetailsSuccess(data)))
      .catch((error) => dispatch(saveNewProductPlacementDetailsFailure(error)));
}

const updateProductPlacementDetailsSuccess = createAction(
  UPDATE_PRODUCT_PLACEMENT_DETAILS_SUCCESS
);
const updateProductPlacementDetailsFailure = createAction(
  UPDATE_PRODUCT_PLACEMENT_DETAILS_FAILURE
);
export function updateProductPlacementDetails(params, id) {
  return (dispatch) =>
    BlankProducts.updateProductPlacementDetails(params, id)
      .then((data) => dispatch(updateProductPlacementDetailsSuccess(data)))
      .catch((error) => dispatch(updateProductPlacementDetailsFailure(error)));
}

const updateBackgroundImageSuccess = createAction(
  UPDATE_BACKGROUND_IMAGES_SUCCESS
);
const updateBackgroundImageFailure = createAction(
  UPDATE_BACKGROUND_IMAGES_FAILURE
);

export function updateBackgroundImage(params, id) {
  return (dispatch) =>
    BlankProducts.updateBackgroundImage(params, id)
      .then((data) => dispatch(updateBackgroundImageSuccess(data)))
      .catch((error) => dispatch(updateBackgroundImageFailure(error)));
}

const getSimilarBlankProductsSuccess = createAction(
  GET_SIMILAR_BLANK_PRODUCTS_SUCCESS
);
const getSimilarBlankProductsFailure = createAction(
  GET_SIMILAR_BLANK_PRODUCTS_FAILURE
);

export function getSimilarBlankProducts(params, id) {
  return (dispatch) =>
    BlankProducts.getSimilarBlankProducts(params, id)
      .then((data) => dispatch(getSimilarBlankProductsSuccess(data)))
      .catch((error) => dispatch(getSimilarBlankProductsFailure(error)));
}

const storeSimilarProductsSuccess = createAction(
  STORE_SIMILAR_PRODUCTS_SUCCESS
);
const storeSimilarProductsFailure = createAction(
  STORE_SIMILAR_PRODUCTS_FAILURE
);

export function storeSimilarProducts(params) {
  return (dispatch) =>
    BlankProducts.storeSimilarProducts(params)
      .then((data) => dispatch(storeSimilarProductsSuccess(data)))
      .catch((error) => dispatch(storeSimilarProductsFailure(error)));
}

/** Starts an async bulk send-to-channel job. Does not wait for completion. */
export function startBulkSendToChannel(data) {
  return BlankProducts.bulkSendToChannel(data);
}

export function getBulkSendToChannelStatus(jobId) {
  return BlankProducts.getBulkSendToChannelStatus(jobId);
}

export const setBulkSendToChannelJob = createAction(SET_BULK_SEND_TO_CHANNEL_JOB);
export const clearBulkSendToChannelJob = createAction(
  CLEAR_BULK_SEND_TO_CHANNEL_JOB
);
